import React, { useEffect } from "react";
import { withRouter } from "react-router";
import { blackBackArrowImage } from "../../assets";
import { invokeApi } from "../../bl_libs/invokeApi";
import Aboutprofile from "./components/About-Profile/Aboutprofile";
import ReviewProfile from "./components/Review-Profile/ReviewProfile";

function ProfileReviews(props) {
  if (!props.location.state) {
    props.history.push("/dashboard/my-requests");
    return <></>;
  }
  const {
    bid,
    comapny_profile,
    truck_count,
    company_rating,
    review_array,
  } = props.location.state;

  return (
    <section id="content-wrapper" className="content-wrapper rating-page">
      <div className="container-fluid">
        <p className="small-text-bold page-title ">
          <img
            className="pointer-point"
            src={blackBackArrowImage}
            onClick={() => props.history.goBack()}
          />
          <span>Profile</span>
        </p>

        <div className="rating-wrapper mt-40 mt-m-30">
          <div className="row">
            <div className="col-12 col-lg-5 col-xl-4">
              <Aboutprofile
                comapny_profile={comapny_profile}
                truck_count={truck_count}
                company_rating={company_rating}
              />
            </div>
            <div className="col-12 col-lg-7 col-xl-8 custom-margin">
              <ReviewProfile review_array={review_array} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default withRouter(ProfileReviews);
